import { useTranslation } from 'react-i18next';

/**
 * " *" after the label or legend of a required field (D25): a red asterisk, hidden from screen readers, which hear
 * "(povinné)" / "(required)" instead. Optional fields carry no marker.
 */
export function RequiredMarker({ required }: { required?: boolean }) {
  const { t, i18n } = useTranslation();
  if (!required) return null;
  return (
    <>
      {/* a non-breaking space: the asterisk never wraps onto a line of its own; the space after it separates the
          hidden text in the accessible name ("Názov (povinné)" – name computations trim the text of an element) */}
      <span className="app-required" aria-hidden="true">
        {'\u00a0*'}
      </span>{' '}
      {/* in the language of the UI also inside a label kept in Slovak (lang="sk") */}
      <span className="govuk-visually-hidden" lang={i18n.resolvedLanguage}>
        {t('common.required')}
      </span>
    </>
  );
}

/** "Povinné polia sú označené hviezdičkou (*)." – at the start of a form that has required fields. */
export function RequiredFieldsNote() {
  const { t } = useTranslation();
  return (
    <p className="govuk-body app-required-note">
      {t('common.requiredNote')} (<span className="app-required">*</span>).
    </p>
  );
}
